import { Button } from "primereact/button";

const ListMembers = ({ category, list, setIsInvite, setCategory }) => {

    function inviteMember() {
        setIsInvite(true);
        setCategory(category);
    }

    return (
        <div className="m-4">
            <h3>{category === "Player" ? "Players" : "Coaches"}: </h3>
            {list.map((p) => (
                <div className="card m-2" style={{ maxWidth: "400px", border: "1px solid #ccc", borderRadius: "5px" }}>
                    <div className="m-3">
                        <div className="d-flex">
                            <div style={{ marginRight: "20px" }}>
                                <label style={{ fontWeight: "bold" }}>Name:</label>
                                <div>{p.userName}</div>
                            </div>
                            <div>
                                <label style={{ fontWeight: "bold" }}>Email:</label>
                                <div>{p.userEmail}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <Button label={`Invite a ${category}`} onClick={() => inviteMember()} className="m-4" />
        </div>
    )
}
export default ListMembers;